var _defs, _rect, _path, _circle, _clipPath, _path2, _g, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use0, _use1, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrazil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 504,
    width: 720,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-2100 -1470 4200 2940",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "D",
    fillRule: "evenodd",
    d: "m-31.5 0h33a30 30 0 0 0 30 -30v-10a30 30 0 0 0 -30 -30h-33zm13-13h19a19 19 0 0 0 19 -19v-6a19 19 0 0 0 -19 -19h-19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    transform: "translate(-31.5)",
    d: "m0 0h63v-13h-51v-18h40v-12h-40v-14h48v-13h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m-26.25 0h52.5v-12h-40.5v-16h33v-12h-33v-11h39.25v-12h-51.25z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "gcut"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-31.5 0v-70h63v70zm31.5-47v12h31.5v-12z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    clipPath: "url(#gcut)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -35,
    x: 5,
    height: 10,
    width: 26.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: -35,
    x: 21.5,
    height: 35,
    width: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "m-31.5 0h12v-48l14 48h11l14-48v48h12v-70h-17.5l-14 48-14-48h-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    fillRule: "evenodd",
    d: "m0 0a31.5 35 0 0 0 0 -70 31.5 35 0 0 0 0 70m0-13a18.5 22 0 0 0 0 -44 18.5 22 0 0 0 0 44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    fillRule: "evenodd",
    d: "m-31.5 0h13v-26h28a22 22 0 0 0 0 -44h-40zm13-39h27a9 9 0 0 0 0 -18h-27z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 0c0-10 0-32-15-32h-19c22 0 22 22 22 32"
  })), /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "m-15.75-22c0 7 6.75 10.5 16.75 10.5s14.74-3.25 14.75-7.75c0-14.25-46.75-5.25-46.5-30.25 0.25-21.5 24.75-20.5 33.75-20.5s26 4 25.75 21.25h-15.25c0-7.5-7-10.25-15-10.25-7.75 0-13.25 1.25-13.25 8.5-0.25 11.75 46.25 4 46.25 28.75 0 18.25-18 21.75-31.5 21.75-11.5 0-31.55-4.5-31.5-22z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "star",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    transform: "rotate(18 0,-1)",
    d: "m0-1v1h0.5"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "scale(-1,1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(216)"
  })), /*#__PURE__*/React.createElement("use", {
    id: "star1",
    xlinkHref: "#star",
    transform: "scale(31.5)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "star2",
    xlinkHref: "#star",
    transform: "scale(26.25)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "star3",
    xlinkHref: "#star",
    transform: "scale(21)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "star4",
    xlinkHref: "#star",
    transform: "scale(15)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "star5",
    xlinkHref: "#star",
    transform: "scale(10.5)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: "-50%",
    x: "-50%",
    height: "100%",
    fill: "#009b3a",
    width: "100%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-1743 0 1743 1113 1743-1113-1743-1113z",
    fill: "#fedf00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 735,
    fill: "#002776"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "band"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 735
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m-2205 1470a1785 1785 0 0 1 3570 0h-105a1680 1680 0 1 0 -3360 0z",
    clipPath: "url(#band)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-420,1470)",
    fill: "#009b3a"
  }, /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#O",
    transform: "rotate(-7)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#R",
    transform: "rotate(-4)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#D",
    transform: "rotate(-1)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#E",
    transform: "rotate(2)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#M",
    transform: "rotate(5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#e",
    transform: "rotate(9.75)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#P",
    transform: "rotate(14.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#R",
    transform: "rotate(17.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#O",
    transform: "rotate(20.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#G",
    transform: "rotate(23.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#R",
    transform: "rotate(26.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#E",
    transform: "rotate(29.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#S",
    transform: "rotate(32.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#S",
    transform: "rotate(35.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#O",
    transform: "rotate(38.5)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1CMi",
    y: -132,
    x: -600,
    xlinkHref: "#star1"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1CMa",
    y: 177,
    x: -535,
    xlinkHref: "#star1"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2CMa",
    y: 243,
    x: -625,
    xlinkHref: "#star2"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3CMa",
    y: 132,
    x: -463,
    xlinkHref: "#star4"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B4CMa",
    y: 250,
    x: -382,
    xlinkHref: "#star2"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5CMa",
    y: 323,
    x: -404,
    xlinkHref: "#star3"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Vir",
    y: -228,
    x: 228,
    xlinkHref: "#star1"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Sco",
    y: 258,
    x: 515,
    xlinkHref: "#star1"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2Sco",
    y: 265,
    x: 617,
    xlinkHref: "#star3"
  })), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5Sco",
    y: 323,
    x: 545,
    xlinkHref: "#star2"
  })), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B8Sco",
    y: 477,
    x: 368,
    xlinkHref: "#star2"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B9Sco",
    y: 551,
    x: 367,
    xlinkHref: "#star3"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03BASco",
    y: 419,
    x: 441,
    xlinkHref: "#star3"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03BBSco",
    y: 382,
    x: 500,
    xlinkHref: "#star2"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03BCSco",
    y: 405,
    x: 365,
    xlinkHref: "#star3"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Hya",
    y: 30,
    x: -280,
    xlinkHref: "#star2"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3Hya",
    y: -37,
    x: 200,
    xlinkHref: "#star3"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Cru",
    y: 330,
    xlinkHref: "#star1"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2Cru",
    y: 184,
    x: 85,
    xlinkHref: "#star2"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3Cru",
    y: 118,
    xlinkHref: "#star2"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B4Cru",
    y: 184,
    x: -74,
    xlinkHref: "#star3"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5Cru",
    y: 235,
    x: -37,
    xlinkHref: "#star4"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1TrA",
    y: 495,
    x: 220,
    xlinkHref: "#star2"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2TrA",
    y: 430,
    x: 283,
    xlinkHref: "#star3"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3TrA",
    y: 412,
    x: 162,
    xlinkHref: "#star3"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Car",
    y: 390,
    x: -295,
    xlinkHref: "#star1"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03C3Oct",
    y: 575,
    xlinkHref: "#star5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazil);
export default __webpack_public_path__ + "static/media/brazil.5c5f5fbb798a16b1f280afb7d2d00585.svg";
export { ForwardRef as ReactComponent };